import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import calendarSaga from "./calendar/saga"

// Token validation and route protection
import { tokenValidationSaga } from "./auth/tokenValidation/saga"
import { routeValidationSaga } from "./auth/routeValidation/saga"
import { redirectSaga } from "./auth/redirect/saga"
import { tokenExpirationSaga } from "./auth/tokenExpiration/saga"
import { networkErrorHandlingSaga } from "./auth/networkErrorHandling/saga"
import { errorDisplaySaga } from "./auth/errorDisplay/saga"
import { apiErrorInterceptorSaga } from "./auth/apiErrorInterceptor/saga"


export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    fork(calendarSaga),
    
    // Token validation and route protection
    fork(tokenValidationSaga),
    fork(routeValidationSaga),
    fork(redirectSaga),
    fork(tokenExpirationSaga),
    fork(networkErrorHandlingSaga),
    fork(errorDisplaySaga),
    fork(apiErrorInterceptorSaga),
  ])
}
